import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FormsItemModule } from '../forms-item/forms-item.module';

import { FormsParagraphComponent } from './forms-paragraph.component';
import { FormsGlobals } from '../../../models/forms/forms.enum';

// material
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    FormsParagraphComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    FormsItemModule,

    MatDividerModule,
    MatGridListModule,
    MatButtonModule
  ],
  exports: [
    FormsParagraphComponent
  ],
  providers: [
    FormsGlobals
  ]
})
export class FormsParagraphModule { }
